import { KiteIcon } from '@kite/react-kite';
import React from 'react';
import './MediaReportButton.scss';

export const MediaReportButton = ({
    title,
    url,
    thin,
}: {
    title: string;
    url: string;
    thin?: boolean;
}) => {
    return (
        <a
            href={url}
            className={`media-report-button kite-button kite-button--shrinkwrap kite-button--sm ${
                thin ? `kite-button--outline-primary` : `kite-button--primary`
            }`}
        >
            <KiteIcon icon="ki-download" />
            {title}
        </a>
    );
};
